import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrivingController, DrivingControllerType } from '../../service/drivingController.service';
import { DISPLAY_DEVICE_OPTIONS, DisplayDeviceType } from '../../service/displayDevice.service';
import { DisplayDeviceIconComponent } from '../../components/displayDeviceIcon.component';

/**
 * Read-only counterpart of <app-member-hero> for the public player page.
 * Shows the driver's avatar, name, PSN and preferred input/output devices with
 * no editing affordances.
 */
@Component({
    selector: 'app-player-hero',
    standalone: true,
    templateUrl: './playerHero.component.html',
    styleUrls: ['./playerHero.component.scss'],
    imports: [CommonModule, DisplayDeviceIconComponent],
})
export class PlayerHeroComponent {
    @Input() name = '';
    @Input() psn?: string;
    @Input() discord?: string;
    /** Avatar as a base64 data URI returned by the API, or null when none is set. */
    @Input() avatar?: string | null;

    /** Catalog of input devices, used to resolve the driver's preference. */
    @Input() controllers: DrivingController[] = [];
    /** The driver's selected device, or null. */
    @Input() controllerId: number | null = null;

    get avatarUrl(): string | null {
        return this.avatar ?? null;
    }

    /** The currently selected device, or undefined when none is chosen. */
    get controller(): DrivingController | undefined {
        return this.controllers.find((c) => c.id === this.controllerId);
    }

    get controllerType(): DrivingControllerType | null {
        return this.controller?.type ?? null;
    }

    get controllerLabel(): string | null {
        const c = this.controller;
        if (!c) return null;
        return `${c.text} (${c.type === 'wheel' ? 'Lenkrad' : 'Controller'})`;
    }

    /** The driver's preferred output device type, or null. */
    @Input() displayDevice: DisplayDeviceType | null = null;

    get displayDeviceLabel(): string | null {
        const d = this.displayDevice;
        if (!d) return null;
        return DISPLAY_DEVICE_OPTIONS.find((o) => o.value === d)?.label ?? d;
    }
}
